module.exports = __webpack_public_path__ + "static/img/img3x.f24becf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family/img3x.png
// module id = fcww
// module chunks = 1